(function () {
  const query = window.matchMedia('(max-width: 989.98px)');
  const typewriterKeys = ['secondPlaceholder', 'thirdPlaceholder', 'fourthPlaceholder'];

  function apply() {
    document.querySelectorAll('input[data-placeholder-mobile][data-placeholder-desktop]').forEach((input) => {
      if (typewriterKeys.some((key) => input.dataset[key])) return;
      input.setAttribute('placeholder', query.matches ? input.dataset.placeholderMobile : input.dataset.placeholderDesktop);
    });
  }

  apply();
  query.addEventListener('change', apply);
})();
